{
  "version": 1,
  "asset_id": "c545c983-d94d-4fdf-ac83-339f2e5fa1f4",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/c545c983-d94d-4fdf-ac83-339f2e5fa1f4/og-business-tax.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/c545c983-d94d-4fdf-ac83-339f2e5fa1f4/og-business-tax.jpg",
  "original_filename": "og-business-tax.jpg",
  "size": 189610,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T16:20:28Z"
}
